<div class="AMCarryOnOfferModal bg-am-medium-blue text-am-white">
  <!-- Botón X eliminado según CI-19083 - Escenario 4 -->
  
  <div class="AMCarryOnOfferModal-content">
    <div class="content-title">
      <img src="./assets/images/bags/modals/carrayon_add.svg" alt="boardin passes" class="size-img"
        *ngIf="typeModal=='offer'">
      <span class="type">{{'carryonOfferModalAdd.carry-on' | translate}}</span>
      <span class="title">{{ tittle | translate }}</span>
    </div>
    <!-- <span class="text-14-regular light-white-color" ng-if="vm.passenger.numBagsDroppedOff > 0 || vm.passenger.numBagsDroppedOff20KG > 0">{{vm.passenger.numBagsDroppedOff + vm.passenger.numBagsDroppedOff20KG}} {{'baggage_selection.piece_already_dropped' | translate}}</span> -->
    <!-- type offer  -->
    <span class="subTitle">{{ 'carryonOfferModalAdd.subTitleOffer' | translate }}</span>
    <div class="content-name">
      <div class="name-passenger">
        <app-am-check-box [check]="statusBag" [topBox]="statusBox" (handleCheck)="onHandleCheck($event)"></app-am-check-box>
        <span class="title20">{{'carryonOfferModalAdd.checktitle' | translate}}</span>
      </div>
    </div>
    <div class="content-passengers">
      <!-- CI-19083: Botón "Viajar sin equipaje" solo se habilita cuando checkbox está marcado -->
      <button 
        class="BagsRedemptionModal-btnNotCarryOn" 
        [disabled]="!statusBag"
        (click)="onClose()">
        {{ 'carryonOfferModalAdd.btnWithoutCarryOnBaggage' | translate }}
      </button>
      <!-- CI-19083: Botón "Agregar equipaje" siempre habilitado -->
      <button class="BagsRedemptionModal-btnCarryOn" (click)="redirect()">
        {{ 'carryonOfferModalAdd.btnAddCarryOnBaggage' | translate }}
      </button>
    </div>
  </div>
</div>
